module.exports = __webpack_public_path__ + "static/img/icon_code.cd857bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/icon_code.png
// module id = xF2Q
// module chunks = 22